import $ from 'jquery';

import {
  initEmbeds,
  setCookie,
  disableAdsInEmbedVideo,
} from '../../../src/js/common/utils/fn';
import { topComments } from '../../../src/js/common/top-comments';
// import $ from 'jquery';
//import ShareBoxInline from '../../../components/shares-box/share-box-inline';

const edition = document.body.dataset.edtn || '';
const colorMode = document.documentElement.getAttribute('data-color-scheme');

export const msntConsent = {
  params: null,
  usedMethods: {
    initEmbeds: new Map(),
    initShareBlock: new Map(),
    initEmbedVideo: new Map(),
    initFeaturedVideo: new Map(),
    initCommentsforCPusers: new Map(),
  },
  shareBlocks: [],
  buttonSelector: '.ot-sdk-show-settings',
  excludeEditions: ['br', 'ev_br'],
  currentEnvironment: document.body.dataset.env,
  isDevelopment: false,
  /**
   * Length of GDPR consent string
   */
  consentStringLength: 11,

  // code to check for inside params.purpose.consents
  CONSENT_CODE: 3,

  initialized: false,

  consentConfig: window?.jsVars?.consent || null,

  init() {
    console.log(
      'init called',
      this.initialized,
      this.consentConfig,
      this.isDevelopment,
    );
    if (this.initialized) return;

    this.initialized = true;

    if (this.isDevelopment || this.isExcludedEdition()) {
      this.handleDevelopmentOrNotApplicable();
    }

    // this will trigger on params changed when Quantcast is used
    // also this will trigger once on start for OneTrust which should set initial params values
    window.__tcfapi?.('addEventListener', 2, (tcData, listenerSuccess) => {
      this.params = tcData;
      this.paramsChanged();
    });

    this.initEvents();
    this.initOneTrust();
    this.initSourcePoint();
  },

  initEvents() {
    const $editSettingsButton = $(this.buttonSelector);

    $editSettingsButton.on('click', () => {
      this.showPrivacyManager();
    });

    $('body').on('click', '.ms-onetrust_stub-button', () => {
      $editSettingsButton.trigger('click');
    });
  },

  /**
   * this will only be true for US
   */
  usnatApplies: null,
  gdprApplies: null,

  showPrivacyManager() {
    if (this.usnatApplies) {
      window?._sp_?.usnat?.loadPrivacyManagerModal?.();
    } else {
      window.__tcfapi?.('displayConsentUi', 2, () => {});

      // required for SourcePoint integration
      window?._sp_?.gdpr?.loadPrivacyManagerModal?.();
    }
  },

  initOneTrust() {
    if (typeof window.OneTrust?.OnConsentChanged !== 'function') return;

    window.OneTrust.OnConsentChanged(() => {
      window.__tcfapi?.('getTCData', 2, (tcData, success) => {
        // tcData.purpose.consents is empty locally, but on production everything seems to be working just fine
        this.params = tcData;
        this.paramsChanged();
      });
    });
  },

  isLoggedIntoContentpass() {
    return document.cookie.includes('_cpauthhint=1');
  },

  initSourcePoint() {
    const isSourcePoint = this.consentConfig?.provider === 'SourcePoint';
    if (!isSourcePoint) return;

    const cfg = this.consentConfig;

    const consentLanguage =
      /** @type { string } */ (document.body.dataset.edtnLocale || 'en').split(
        '-',
      )[0] || 'en';

    if (!cfg.groupPmIdUS) {
      this.usnatApplies = false;
    }

    window._sp_queue = window._sp_queue || [];
    window._sp_ = window._sp_ || {};

    window._sp_.config = {
      accountId: cfg.accountId,
      baseEndpoint: 'https://cdn.privacy-mgmt.com',
      gdpr: { groupPmId: cfg.groupPmId },
      usnat: cfg.groupPmIdUS ? { groupPmId: cfg.groupPmIdUS } : undefined,
      consentLanguage,
      propertyId: cfg.propertyId,
      targetingParams: {
        edition,
        colorMode: colorMode ? colorMode : 'light',
        acps: this.isLoggedIntoContentpass() ? 'true' : 'false',
      },
      isSPA: !!window?.jsVars?.contentpassEnabled,
      events: {
        onMessageChoiceSelect: (...args) => {
          console.log('[CMP SP] onMessageChoiceSelect', args);
        },
        onMessageReady: (...args) => {
          console.log('[CMP SP] onMessageReady', args);
        },
        onMessageChoiceError: (...args) => {
          console.log('[CMP SP] onMessageChoiceError', args);
        },
        onPrivacyManagerAction: (...args) => {
          console.log('[CMP SP] onPrivacyManagerAction', args);
        },
        onPMCancel: (...args) => {
          console.log('[CMP SP] onPMCancel', args);
        },
        onMessageReceiveData: (...args) => {
          console.log('[CMP SP] onMessageReceiveData', args);
        },
        onSPPMObjectReady: (...args) => {
          console.log('[CMP SP] onSPPMObjectReady', args);
        },
        onConsentReady: this.handleSPConsentReady.bind(this),
        onError: (...args) => {
          console.log('[CMP SP] onError', args);
        },
      },
    };

    // window._sp_queue = [];
    // window._sp_ = {
    //   // https://docs.sourcepoint.com/hc/en-us/articles/4405412419731-Client-configuration-parameters
    //   config: {
    //     accountId: cfg.accountId,
    //     baseEndpoint: 'https://cdn.privacy-mgmt.com',
    //     gdpr: {
    //       groupPmId: cfg.groupPmId,
    //     },
    //     usnat: cfg.groupPmIdUS
    //       ? {
    //           groupPmId: cfg.groupPmIdUS,
    //         }
    //       : undefined,
    //     consentLanguage,
    //     propertyId: cfg.propertyId,
    //     targetingParams: {
    //       edition,
    //       colorMode: colorMode ? colorMode : 'light',
    //       acps: this.isLoggedIntoContentpass() ? 'true' : 'false',
    //     },
    //     isSPA: !!window?.jsVars?.contentpassEnabled,

    //     /**
    //      * !!!IMPORTANT!!! make sure it's not set or is commented for production (propertyId will be used there)
    //      * this can be used to make it run locally. Also we need to enable it in development/sources.php
    //      * List of allowed domains available here https://portal.sourcepoint.com/dialogue/sites?tab=properties
    //      */
    //     // propertyHref: 'https://www.motor1.com',
    //     events: {
    //       onMessageChoiceSelect: (...args) => {
    //         console.log('[CMP SP] onMessageChoiceSelect', args);
    //       },
    //       onMessageReady: (...args) => {
    //         console.log('[CMP SP] onMessageReady', args);
    //       },
    //       onMessageChoiceError: (...args) => {
    //         console.log('[CMP SP] onMessageChoiceError', args);
    //       },
    //       onPrivacyManagerAction: (...args) => {
    //         console.log('[CMP SP] onPrivacyManagerAction', args);
    //       },
    //       onPMCancel: (...args) => {
    //         console.log('[CMP SP] onPMCancel', args);
    //       },
    //       onMessageReceiveData: (...args) => {
    //         console.log('[CMP SP] onMessageReceiveData', args);
    //       },
    //       onSPPMObjectReady: (...args) => {
    //         console.log('[CMP SP] onSPPMObjectReady', args);
    //       },
    //       onConsentReady: this.handleSPConsentReady.bind(this),
    //       onError: (...args) => {
    //         console.log('[CMP SP] onError', args);
    //       },
    //     },
    //   },
    // };

    console.log('window._sp_', window._sp_);
  },

  handleSPConsentReady(messageType, consentUUID, eucConsent, settings = {}) {
    console.log('[CMP SP] onConsentReady', [
      messageType,
      consentUUID,
      eucConsent,
      settings,
    ]);

    const consentApplies = settings.applies;

    // wait for both consents or only one if other is null
    // only after both are available - make decision that not applies
    if (messageType === 'usnat') {
      // this will be set to false during initialization if no usnat script is loaded
      this.usnatApplies = consentApplies;
    } else if (messageType === 'gdpr') {
      this.gdprApplies = consentApplies;
    }

    // We have to do this because SourcePoint doesn't send default values if consent doesn't apply
    if (this.gdprApplies === false && this.usnatApplies === false) {
      // eslint-disable-next-line no-console
      console.log(
        `[CMP SP] consent does not apply for this region. Set all to enabled.`,
      );

      // if consent is not required for current country, we need to update values is GCM (Google Consent Mode)
      const newGCM = {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
      };
      window.gtag?.('consent', 'update', newGCM);

      gtmDataLayer.push({
        event: 'spConsentUpdated',
        consentType: 'gdpr',
        consentString: '1'.repeat(this.consentStringLength),
        consentApplies: false,
        consentAll: true,
      });

      this.handleDevelopmentOrNotApplicable();
    }

    if (!this.isLoggedIntoContentpass()) {
      Array.from(document.querySelectorAll('.optanon-category-C0003')).forEach(
        (script) => {
          const newScript = document.createElement('script');
          newScript.src = script.src;
          newScript.id = script.id;
          newScript.type = 'text/javascript';
          script.replaceWith(newScript);
        },
      );
    }

    if (consentApplies) {
      if (messageType === 'gdpr') {
        window.__tcfapi?.('addEventListener', 2, (tcData, listenerSuccess) => {
          // we will use this inside of GTM to figure out which groups are enabled
          const consentString = consentApplies
            ? Object.values(tcData.purpose.consents)
                .map((val) => (val ? '1' : '0'))
                .join('')
            : '1'.repeat(this.consentStringLength);

          console.log(`[CMP SP] gdpr consentString  => `, consentString);

          gtmDataLayer.push({
            event: 'spConsentUpdated',
            consentType: messageType,
            consentString,
            consentApplies,
            consentAll: settings.consentedToAll,
          });

          console.log(
            'DEBUG WHAT HAPPENED',
            tcData,
            consentString,
            consentApplies,
          );

          // this.setMSNTConsentStateFromTCData(tcData);
          this.params = tcData;
          this.paramsChanged();
        });
      } else if (messageType === 'usnat') {
        window._sp_.usnat.getUserConsents((data, success) => {
          const isConsented = success && data.categories[0].consented;

          console.log(
            `[CMP SP] usnat first category consented  => `,
            isConsented,
          );

          const consentString = (isConsented ? '1' : '0').repeat(
            this.consentStringLength,
          );
          const consentAll = isConsented;

          const consentValue = isConsented ? 'granted' : 'denied';

          // we have to send new correct value on each change, because SourcePoint doesn't do this
          const newGCM = {
            ad_storage: consentValue,
            ad_user_data: consentValue,
            ad_personalization: consentValue,
            analytics_storage: consentValue,
            functionality_storage: consentValue,
          };
          window.gtag?.('consent', 'update', newGCM);

          if (consentAll) {
            this.handleDevelopmentOrNotApplicable();
          } else {
            this.params = null;
            this.paramsChanged();
          }

          gtmDataLayer.push({
            event: 'spConsentUpdated',
            consentType: messageType,
            consentString,
            consentApplies,
            consentAll,
          });
        });
      }
    }
  },

  handleDevelopmentOrNotApplicable() {
    this.params = {
      purpose: {
        consents: {
          3: true,
        },
      },
    };
    this.paramsChanged();
  },

  getParams() {
    // if (!this.params) {
    //   this.params = {};
    // }

    return this.params || {};
  },

  isAllowed(code) {
    const params = this.getParams();
    // console.log('PARAMS', params, params?.applies, params?.purpose?.consents?.[code])

    return params?.applies || !!params?.purpose?.consents?.[code];
  },

  isAdsAllowed() {
    return this.isAllowed(this.CONSENT_CODE);
  },

  isSocialsAllowed() {
    return this.isAllowed(this.CONSENT_CODE);
  },

  isExcludedEdition() {
    return this.excludeEditions.includes(edition);
  },

  initEmbeds($page) {
    if (!this.usedMethods['initEmbeds'].has($page)) {
      this.usedMethods['initEmbeds'].set($page, $page);
    }

    if (
      this.currentEnvironment == 'development' ||
      this.currentEnvironment == 'stage' ||
      this.currentEnvironment == 'test'
    ) {
      if (this.initialized) {
        // return;
        console.log('INITIALIZE COMPLETED', this.initialized);
      }
    } else {
      if (!this.initialized) {
        return;
      }
    }

    if (
      this.currentEnvironment === 'development' ||
      this.currentEnvironment == 'test'
    ) {
      initEmbeds($page);
      return;
    }

    console.log('this.isSocialsAllowed', this.isSocialsAllowed);

    if (!this.isSocialsAllowed()) {
      console.log(
        'INSIDE IF !this.isSocialsAllowed()',
        this.isSocialsAllowed(),
      );
      $page.find('.embed-item').each((index, element) => {
        $(element).empty().append(this.getStub());
      });

      $page.find('.ms-share_twitter').hide();
      return;
    }

    $page.find('.ms-share_twitter').show();
    initEmbeds($page);
    let setInstagramInterval = setInterval(function () {
      if (typeof instgrm === 'object') {
        instgrm.Embeds.process();
        clearInterval(setInstagramInterval);
      }
    }, 2500);
  },

  initCommentsforCPusers($page) {
    const $body = $(document.body);
    const msntLoginScript = document.createElement('script');
    msntLoginScript.src =
      'https://accounts.motorsportnetwork.com/api/v1.0/script/81';

    if (!this.usedMethods['initCommentsforCPusers'].has($page)) {
      this.usedMethods['initCommentsforCPusers'].set($page, $page);
    }

    if (
      this.currentEnvironment == 'development' ||
      this.currentEnvironment == 'stage' ||
      this.currentEnvironment == 'test'
    ) {
      if (this.initialized) {
        return;
      }
    } else {
      if (!this.initialized) {
        return;
      }
    }

    if (!this.isAdsAllowed()) {
      $page.find('#comments-stub').each((index, element) => {
        $(element).empty().append(this.getStub());
      });
      return;
    } else {
      $page.find('#comments-stub').each((index, element) => {
        $(element).remove();
      });

      $page
        .find('#comments .commentsNumber.show-disqus.show-coral')
        .css('display', 'inline-flex');

      document.head.appendChild(msntLoginScript);
      topComments.init({
        config: { active: 1 },
      });

      $page
        .find('#comments .commentsNumber.show-disqus.show-coral')
        .on('click', function (e) {
          const topCommentsBlockck = document.querySelector('.m1-top-comments');
          $(this).hide();
          $(topCommentsBlockck).hide();
        });
    }
  },

  initEmbedVideo($page) {
    if (!this.usedMethods['initEmbedVideo'].has($page)) {
      this.usedMethods['initEmbedVideo'].set($page, $page);
    }

    if (
      this.currentEnvironment == 'development' ||
      this.currentEnvironment == 'stage' ||
      this.currentEnvironment == 'test'
    ) {
      if (this.initialized) {
        return;
      }
    } else {
      if (!this.initialized) {
        return;
      }
    }

    if (!this.isAdsAllowed()) {
      setCookie('cpuserNoVideo', 1);
      $page.find('.video-player').each((index, element) => {
        if (!$(element).parent().hasClass('videoBoxArticle-wrapper')) {
          $(element).hide().parent().append(this.getStub());
        }
      });
      return;
    } else {
      setCookie('cpuserNoVideo', 0);
      disableAdsInEmbedVideo();
      $page.find('.video-player').each((index, element) => {
        if ($(element).parent().hasClass('videoBoxArticle-wrapper')) {
          var $videoWrapper = $('.videoBoxArticle .video-player');
          const clearSvg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
              <title>clear</title>
              <path d="M25.312 9.216l-7.424 7.456 7.424 7.424-1.888 1.888-7.424-7.456-7.424 7.456-1.888-1.888 7.424-7.424-7.424-7.456 1.888-1.856 7.424 7.424 7.424-7.424z"></path>
              </svg>`;
          if (!$videoWrapper.hasClass('other-videos-video-player')) {
            $videoWrapper.html(
              '<div class="video-player-close icon-cross">' +
                clearSvg +
                '</div><iframe allowfullscreen frameborder="0" allow="autoplay" src="' +
                $videoWrapper.data('video-url') +
                '"></iframe>',
            );
          }
        } else {
          $('.video-player').nextAll('.ms-onetrust_stub').remove();
          $(element).show();
        }
      });
    }
  },

  initShareBlock($page) {
    if (!this.usedMethods['initShareBlock'].has($page)) {
      this.usedMethods['initShareBlock'].set($page, $page);
    }

    if (
      this.currentEnvironment == 'development' ||
      this.currentEnvironment == 'stage' ||
      this.currentEnvironment == 'test'
    ) {
      if (this.initialized) {
        return;
      }
    } else {
      if (!this.initialized) {
        return;
      }
    }

    if (
      this.currentEnvironment === 'development' ||
      this.currentEnvironment == 'test'
    ) {
      $page.find('.shareBox').show();
      return;
    }

    if (!this.isSocialsAllowed()) {
      $page.find('.shareBox').hide();
      return;
    }

    $page.find('.shareBox').show();
  },

  paramsChanged() {
    for (const methodName in this.usedMethods) {
      if (
        this.usedMethods.hasOwnProperty(methodName) &&
        this.hasOwnProperty(methodName)
      ) {
        for (let params of this.usedMethods[methodName].values()) {
          this[methodName](params);
        }
      }
    }
  },

  getStub() {
    return `<div class="ms-onetrust_stub" data-widget="ms-onetrust_stub">
                <h3 class="ms-onetrust_stub-title">${i18n.cookie_settings}</h3>
                <p class="ms-onetrust_stub-text">${i18n.content_blocked}</p>
                <p class="ms-onetrust_stub-text">${i18n.click_to_show_content}</p>
                <div class="ms-onetrust_stub-button">${i18n.open_settings}</div>
              </div>`;
  },
};

window.msntConsent = msntConsent;

window.msntConsent.init();
